import styled from 'styled-components';

export const CloseSurface = styled.div`
  height: 100vh;
  position: fixed;
  width: 100vw;
`;

export const CloseWrapper = styled.div`
  top: 35px;
  position: absolute;
  left: 35px;
  z-index: 30;
`;

export const Image = styled.img`
  display: block;
  left: 50%;
  margin: auto;
  max-width: 100%;
  max-height: calc(100% - 150px);
  object-fit: contain;
  padding: 5px;
  position: absolute;
  top: calc(50% - 35px);
  transform: translate(-50%, -50%);
`;

export const ImageSubWrapper = styled.div`
  height: 75vh;
  max-width: 75vw;
  min-width: 75vw;
  padding: 35px;
`;

export const Label = styled.p`
  color: ${p => p.theme.color.headerPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 20px;
  margin: 0;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LabelWrapper = styled.div`
  background-color: #ebebeb;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px 35px;
  text-align: left;
  width: 100%;
`;

export const Screen = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.64);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 30;
`;

export const Wrapper = styled.div`
  background-color: ${p => p.theme.product.specs.imagesBackground};
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
  position: relative;
  z-index: 30;
`;
